/* istanbul ignore file */

import { connect } from 'react-redux'
import { createWidget } from 'pages/widgets/form-actions/create/actions'
import Form from 'pages/widgets/form'
import { getInitialFbReminderValues } from './initialValues'

const mapDispatch = {
  onSubmit: createWidget
}

const date = new Date().valueOf()

export default connect(
  () => ({ initialValues: getInitialFbReminderValues(date) }),
  mapDispatch
)(Form)



// WEBPACK FOOTER //
// ./src/pages/widgets/fb-reminder/create/container/index.js